import { useEffect } from 'react'
import { subscribe, unsubscribe } from '@/utils/events'

export function useAuthLegacyEvents ({
  openLoginModal,
  openSignupModal,
  closeModal,
  logoutExpired,
  logout,
}) {
  useEffect(() => {
    subscribe('openLoginModal', openLoginModal)
    subscribe('openSignupModal', openSignupModal)
    subscribe('closeModal', closeModal)
    subscribe('logoutExpired', logoutExpired)
    subscribe('logout', logout)

    return () => {
      unsubscribe('openLoginModal', openLoginModal)
      unsubscribe('openSignupModal', openSignupModal)
      unsubscribe('closeModal', closeModal)
      unsubscribe('logoutExpired', logoutExpired)
      unsubscribe('logout', logout)
    }
  }, [openLoginModal, openSignupModal, closeModal, logoutExpired, logout])
}
